/* This example requires Tailwind CSS v2.0+ */
import {Fragment, useMemo} from 'react'
import {Dialog, Transition} from '@headlessui/react'
import {BellAlertIcon, CheckIcon} from '@heroicons/react/24/outline'
import {ExclamationTriangleIcon} from "@heroicons/react/20/solid"
import loaderImage from "../assets/images/grid-loader.svg"
import {useClientContext} from "../contexts/ClientContext"

const INFO = 'INFO'
const INFO_SPINNER = 'INFO_SPINNER'
const ERROR = 'ERROR'

export const modalType = {
    Info: INFO,
    InfoSpinner: INFO_SPINNER,
    Error: ERROR
}

export default function Modal() {

    const {showModal, modalData, setShowModal} = useClientContext()
    const modalTypeIcon = useMemo(() => {
        return () => {
            switch (modalData.type) {
                case modalType.Info:
                case modalType.InfoSpinner:
                    return (
                        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-blue-100">
                            <BellAlertIcon className="h-6 w-6 text-blue-600" aria-hidden="true"/>
                        </div>
                    )
                case modalType.Error:
                    return (
                        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
                            <ExclamationTriangleIcon className="h-6 w-6 text-red-600" aria-hidden="true"/>
                        </div>
                    )
            }
        }
    }, [modalData])

    return (
        <Transition.Root show={showModal} as={Fragment}>
            <Dialog as="div" className="relative z-10" onClose={() => null}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"/>
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel
                                className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                                <div>
                                    {modalTypeIcon()}
                                    <div className="mt-3 text-center sm:mt-5">
                                        <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                                            {modalData.title}
                                        </Dialog.Title>
                                        <div className="mt-2">
                                            <p className="text-sm text-gray-500">
                                                {modalData.message}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                { modalData.type === modalType.InfoSpinner &&
                                    <div className="mt-5 mx-auto">
                                        <img className={'mx-auto h-12'} src={loaderImage}/>
                                    </div>
                                }
                                { modalData.type === modalType.Error &&
                                    <div className="mt-5 sm:mt-6">
                                        <button
                                            type="button"
                                            className="inline-flex w-full justify-center rounded-md border border-transparent bg-red-600 px-4 py-2 text-base font-medium text-white shadow-sm sm:text-sm"
                                            onClick={() => setShowModal(false)}
                                        >
                                            Close
                                        </button>
                                    </div>
                                }
                                { modalData.type === modalType.Info &&
                                    <div className="mt-5 sm:mt-6">
                                        <button
                                            type="button"
                                            className="inline-flex w-full justify-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-base font-medium text-white shadow-sm sm:text-sm"
                                            onClick={() => setShowModal(false)}
                                        >
                                            Close
                                        </button>
                                    </div>
                                }
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}
